module.exports = __webpack_public_path__ + "static/liva-convert-detail-489c666e636cdc7f7f2271764d465e8c.png";